import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import styles from './index.scss';

class InfoBlockText extends Component {
    state = {
        moreProgram: false,
        moreRules: false,
    };

    toggleItems = name => () => {
        this.setState({
            [name]: !this.state[name],
        });
    };

    render() {
        const blockProgramClasses = classNames({
            [styles.tradeUpsInfoFullWidth]: true,
            [styles.showMoreItems]: this.state.moreProgram,
        });

        const blockRulesClasses = classNames({
            [styles.tradeUpsInfoFullWidth]: true,
            [styles.showMoreItems]: this.state.moreRules,
        });

        const additionalInfoClasses = classNames({
            [styles.additionalText]: true,
            [styles.toggleVisibility]: true,
        });

        const showItemsTogglerWrapProgramClasses = classNames({
            [styles.showItemsTogglerWrap]: true,
            [styles.showItemsTogglerWrap_less]: this.state.moreProgram,
        });

        const showItemsTogglerWrapRulesClasses = classNames({
            [styles.showItemsTogglerWrap]: true,
            [styles.showItemsTogglerWrap_less]: this.state.moreRules,
        });

        const iconProgramClasses = classNames({
            [styles.expand]: true,
            [styles.expand_less]: this.state.moreProgram,
        });

        const iconRulesClasses = classNames({
            [styles.expand]: true,
            [styles.expand_less]: this.state.moreRules,
        });

        return (
            <React.Fragment>
                <div className={blockProgramClasses}>
                    <h3 className={`${styles.tradeUpsInfoHeading} capitalizeFirstLetter`}>
                        <FormattedMessage id={'tradeUps_about'} />
                    </h3>
                    <p className={styles.tradeUpsInfoPromoText}>
                        <FormattedMessage id={'tradeUps_infoBlock1'} />
                    </p>
                    <div className={styles.tradeUpsInfoInnerPadding}>
                        <ul>
                            <li>
                                <div className={styles.listItem}>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'accessoriesDiscount'} />
                                    </h4>
                                    <p>
                                        <FormattedMessage id={'customersBenefitMessage'} />
                                    </p>
                                </div>
                            </li>
                            <li className={styles.toggleVisibility}>
                                <div className={styles.listItem}>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'upgradeMessage'} />
                                    </h4>
                                    <p>
                                        <FormattedMessage id={'tradeInToCurrentUPS'} />
                                    </p>
                                </div>
                            </li>
                            <li className={styles.toggleVisibility}>
                                <div className={styles.listItem}>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'freeRemovalShippingText'} />
                                    </h4>
                                    <p>
                                        <FormattedMessage id={'tradeUps_infoBlock2'} />
                                        <p className={styles.clarificationText}>
                                            <FormattedMessage id={'tradeUps_infoBlock2_note'} />
                                        </p>
                                    </p>
                                </div>
                            </li>
                            <li className={styles.toggleVisibility}>
                                <div className={styles.listItem}>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'ecologicalText'} />
                                    </h4>
                                    <p>
                                        <FormattedMessage id={'oldUnitsText'} />
                                    </p>
                                </div>
                            </li>
                            <li className={styles.toggleVisibility}>
                                <div>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'tradeUPS_info2'} />
                                    </h4>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className={showItemsTogglerWrapProgramClasses}>
                        <div className={styles.showItemsToggler} onClick={this.toggleItems('moreProgram')}>
                            <div className={styles.showItemsTogglerText}>
                                {this.state.moreProgram ? (
                                    <FormattedMessage id={'tradeUps_showLess'} />
                                ) : (
                                    <FormattedMessage id={'tradeUps_showMore'} />
                                )}
                            </div>
                            <div className={iconProgramClasses} />
                        </div>
                    </div>
                </div>

                <div className={blockRulesClasses}>
                    <h3 className={`${styles.tradeUpsInfoHeading} capitalizeFirstLetter`}>
                        <FormattedMessage id={'tradeUps_programRules'} />
                    </h3>
                    <p className={styles.tradeUpsInfoPromoText}>
                        <FormattedMessage id={'participateText'} />
                    </p>
                    <div className={styles.tradeUpsInfoInnerPadding}>
                        <ul>
                            <li>
                                <div className={styles.listItem}>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'tradeUps_tradeInSingleUps'} />
                                    </h4>
                                    <p>
                                        <FormattedMessage id={'tradeUps_tradeInSingleUps_rule'} />
                                    </p>
                                </div>
                            </li>
                            <li className={styles.toggleVisibility}>
                                <div className={styles.listItem}>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'tradeUps_tradeInMultipleUps'} />
                                    </h4>
                                    <p>
                                        <FormattedMessage id={'tradeUps_tradeInMultipleUps_rule'} />
                                    </p>
                                </div>
                            </li>
                            <li className={styles.toggleVisibility}>
                                <div className={styles.listItem}>
                                    <h4 className={styles.tradeUpsInfoSubHeading}>
                                        <FormattedMessage id={'tradeUps_crossSellPurchases'} />
                                    </h4>
                                    <p>
                                        <FormattedMessage id={'maximumPurchaseText'} />
                                    </p>
                                </div>
                            </li>
                        </ul>
                        <p className={additionalInfoClasses}>
                            <p className={styles.smallText}>
                                <FormattedMessage id={'tradedReturnText'} />
                            </p>
                            <p className={styles.smallText}>
                                <FormattedMessage id={'apcRightToRefuseText'} />
                            </p>
                        </p>
                    </div>

                    <div className={showItemsTogglerWrapRulesClasses}>
                        <div className={styles.showItemsToggler} onClick={this.toggleItems('moreRules')}>
                            <div className={styles.showItemsTogglerText}>
                                {this.state.moreRules ? (
                                    <FormattedMessage id={'tradeUps_showLess'} />
                                ) : (
                                    <FormattedMessage id={'tradeUps_showMore'} />
                                )}
                            </div>
                            <div className={iconRulesClasses} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

InfoBlockText.propTypes = {};
InfoBlockText.defaultProps = {};

export default InfoBlockText;
